import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "./ui/card";
import { Radar } from "lucide-react";

const eur = (v) => Number(v || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
const PERIODS = [30, 90, 365];

// Riepilogo "Lead per canale": provenienza (Google, Facebook…), appuntamenti, contratti e valore firmato.
export default function LeadChannels() {
  const [days, setDays] = useState(90);
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(`/dashboard/channels?days=${days}`).then(({ data }) => setRows(data.channels)).catch(() => setRows([])); }, [days]);
  const max = Math.max(1, ...(rows || []).map((r) => r.lead));
  return (
    <Card className="rounded border-border p-5 mt-6" data-testid="lead-channels-card">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-2"><Radar className="h-4 w-4 text-primary" /><h3 className="font-heading font-semibold">Lead per canale</h3></div>
        <div className="flex gap-1">
          {PERIODS.map((d) => (
            <button key={d} onClick={() => setDays(d)} className={`px-2.5 py-1 rounded text-xs border transition-colors ${days === d ? "bg-primary text-primary-foreground border-primary" : "border-border text-muted-foreground hover:text-foreground"}`} data-testid={`channels-period-${d}`}>{d === 365 ? "12 mesi" : `${d} gg`}</button>
          ))}
        </div>
      </div>
      {!rows ? <p className="text-xs text-muted-foreground">Caricamento…</p> : rows.length === 0 ? <p className="text-xs text-muted-foreground">Nessun lead nel periodo.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="lead-channels-table">
            <thead><tr className="text-[10px] uppercase tracking-widest text-muted-foreground text-left">
              <th className="py-2 pr-3">Canale</th><th className="py-2 pr-3 w-1/3">Lead</th><th className="py-2 pr-3 text-right">Appuntamenti</th><th className="py-2 pr-3 text-right">Contratti</th><th className="py-2 pr-3 text-right">Conversione</th><th className="py-2 text-right">Valore firmato</th>
            </tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.canale} className="border-t border-border/60" data-testid={`channel-row-${r.canale}`}>
                  <td className="py-2 pr-3">
                    <div className="font-medium">{r.canale}</div>
                    {r.campagne?.length > 0 && <div className="text-[11px] text-muted-foreground truncate max-w-[220px]" title={r.campagne.map((c) => `${c.nome} (${c.lead})`).join(", ")}>{r.campagne.map((c) => c.nome).join(" · ")}</div>}
                  </td>
                  <td className="py-2 pr-3">
                    <div className="flex items-center gap-2"><div className="h-2 rounded bg-primary" style={{ width: `${(r.lead / max) * 100}%`, minWidth: 4 }} /><span className="text-xs tabular-nums">{r.lead}</span></div>
                    {r.a_pagamento > 0 && <div className="text-[10px] text-muted-foreground">{r.a_pagamento} da annunci</div>}
                  </td>
                  <td className="py-2 pr-3 text-right tabular-nums">{r.appuntamenti}</td>
                  <td className="py-2 pr-3 text-right tabular-nums">{r.contratti}</td>
                  <td className="py-2 pr-3 text-right tabular-nums">{r.lead ? Math.round((r.contratti / r.lead) * 100) : 0}%</td>
                  <td className="py-2 text-right tabular-nums">{eur(r.valore)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="text-[11px] text-muted-foreground mt-3">"Non tracciato" = lead inseriti a mano o arrivati prima dell'attivazione del rilevamento. Per riconoscere le campagne aggiungi i codici utm ai link degli annunci.</p>
        </div>
      )}
    </Card>
  );
}
